import { render, staticRenderFns } from "./FacebookPrice.vue?vue&type=template&id=d4b9f7d2&scoped=true&"
import script from "./FacebookPrice.vue?vue&type=script&lang=js&"
export * from "./FacebookPrice.vue?vue&type=script&lang=js&"
import style0 from "./FacebookPrice.vue?vue&type=style&index=0&id=d4b9f7d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b9f7d2",
  null
  
)

export default component.exports